module.exports = __webpack_public_path__ + "img/place.3584c497.svg";